<style scoped lang="scss">
.Log-content-div {
    background-color: rgb(242 242 242) !important;
    min-width: fit-content;

    .liu-text-success {
        color: #10b981;
        font-weight: 500;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1.25rem;

        &::before {
            content: '\2705';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .liu-text-danger {
        color: #ef4444;
        font-weight: 500;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1.25rem;

        &::before {
            content: '\274C';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}

.liu-text-info {
    color: #1a1a1a;
    font-weight: 500;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
}


.liu-text-warning {
    color: #f59e0b;
    font-weight: 500;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
}

.liu-text-primary {
    color: #3b82f6;
    font-weight: 500;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
}

.log_data-div {
    border-radius: 16px;
    box-shadow:
        0 10px 30px rgba(0, 0, 0, 0.08),
        0 0 0 1px rgba(107, 70, 193, 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(to bottom, #6B46C1, #805AD5);
        border-radius: 2px;
    }

    &:hover {
        box-shadow:
            0 20px 40px rgba(0, 0, 0, 0.12),
            0 0 0 1px rgba(107, 70, 193, 0.1);
    }
}

:deep(.el-table) {
    --el-table-border-color: rgba(107, 70, 193, 0.1);
    --el-table-header-bg-color: #f8fafc;

    th {
        background: #f8fafc;
        font-weight: 600;
        color: #1a1a1a;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        padding: 1.25rem 1rem;
        border-bottom: 1px solid rgba(107, 70, 193, 0.1);
        position: relative;

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 1rem;
            width: calc(100% - 2rem);
            height: 1px;
            background: linear-gradient(to right, rgba(107, 70, 193, 0.1), rgba(107, 70, 193, 0.2), rgba(107, 70, 193, 0.1));
        }
    }

    td {
        color: #1a1a1a;
        font-size: 0.95rem;
        padding: 1.25rem 1rem;
        font-weight: 500;
        transition: all 0.2s ease;
        border-bottom: 1px solid rgba(107, 70, 193, 0.05);
    }

    tr {
        transition: all 0.2s ease;

        &:hover {
            td {
                background: rgba(107, 70, 193, 0.02);
            }
        }
    }
}

.pagination {
    margin: 2rem auto 0;
    width: fit-content;

    :deep(.el-pagination__total),
    :deep(.el-pagination__sizes) {
        margin-right: 1.25rem;
        font-size: 0.95rem;
        color: #4a5568;
    }

    :deep(.btn-prev),
    :deep(.btn-next) {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        transition: all 0.2s ease;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    }

    :deep(.el-pager li) {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        transition: all 0.2s ease;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        &.is-active {
            background: #6B46C1;
            color: white;
            box-shadow: 0 4px 12px rgba(107, 70, 193, 0.25);
        }
    }
}

//移动端
@media screen and (max-width: 768px) {
    .log_data-div {
        margin-left: 1rem;
        width: 90vw;
        background-color: white;
        padding-bottom: 1.5rem;
        margin-top: 1rem;
        padding-top: 50px;
    }
}

// pc端
@media screen and (min-width: 768px) {
    .log_data-div {
        padding-top: 50px;
        margin-left: 3rem;
        width: 80vw;
        background-color: white;
        padding-bottom: 1.5rem;
        margin-top: 1.5rem;
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height:100vh;padding-left: 0;background-color: rgb(242, 242, 242) !important;overflow: auto;">
                    <div class="Log-content-div">
                        <div style="margin-bottom: 4rem;">
                            <div class="log_data-div rounded shadow">
                                <el-table :data="log_data" class="log_data" width="100%" stripe border>
                                    <el-table-column prop="id" label="id" />
                                    <el-table-column prop="log_act" label="日志类型">
                                        <template v-slot="scope">
                                            <div
                                                :class="{ 'liu-text-info': scope.row.log_act == 3 || scope.row.log_act == 4, 'liu-text-success': scope.row.log_act == 1 || scope.row.log_act == 5, 'liu-text-danger': scope.row.log_act == 2 }">
                                                {{ getLogAct(scope.row.log_act) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="log_desc" label="内容" width="300" />
                                    <el-table-column prop="afterMoney" label="交易后">
                                        <template v-slot="scope">
                                            <div class="liu-text-primary" v-if="scope.row.afterMoney != undefined">{{
                                                scope.row.afterMoney }}</div>
                                            <div class="liu-text-info" v-else>无</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="beforeMoney" label="交易前">
                                        <template v-slot="scope">
                                            <div class="liu-text-warning" v-if="scope.row.beforeMoney != undefined">{{
                                                scope.row.beforeMoney }}</div>
                                            <div class="liu-text-info" v-else>无</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="operationMoney" label="操作金额">
                                        <template v-slot="scope">
                                            <div :class="{ 'liu-text-danger': scope.row.log_act == 2, 'liu-text-success': scope.row.log_act == 1 || scope.row.log_act == 5 }"
                                                v-if="scope.row.operationMoney != undefined">{{
                                                    scope.row.operationMoney }}</div>
                                            <div class="liu-text-info" v-else>无</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="add_time" label="时间" width="200">
                                    </el-table-column>
                                </el-table>
                                <el-pagination class="pagination" v-model:current-page="log_Conf.currentPage"
                                    v-model:page-size="log_Conf.pageSize" :page-sizes="[10, 25, 50]" :small="small"
                                    :disabled="disabled" :background="background"
                                    layout="total, sizes, prev, pager, next, jumper" :total="log_Conf.total"
                                    @size-change="logSizeChange" @current-change="logCurrentChange" />
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            log_Conf: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            log_data: []
        }
    }, methods: {
        getLogAct(act) {
            //    1:收入，2：支出，3：登录，4，其他
            switch (act) {
                case 1:
                    return "收入"
                case 2:
                    return "支出"
                case 3:
                    return "登录"
                case 4:
                    return "其他"
                case 5:
                    return "作者收入"
                default:
                    return "未知"
            }
        },
        getUserLog() {
            openLoading()
            const data = new FormData();
            data.append("page", this.log_Conf.currentPage)
            data.append("pageSize", this.log_Conf.pageSize)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/userApi/getUserLog', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                        return
                    }
                    if (res.data.code == 200) {
                        this.log_data = res.data.data
                        this.log_Conf.total = res.data.total
                        return;
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        logSizeChange(val) {
            this.log_Conf.pageSize = val
            this.getUserLog()
        },
        logCurrentChange(val) {
            this.log_Conf.currentPage = val
            this.getUserLog()
        },
    },
    mounted() {
        this.getUserLog()
    }
})
</script>
